import { PaddingType } from 'common/types/styleTypes'
import { mobilePaddingsCss, paddingsCss } from 'common/utils/styleUtilsNew'
import styled from 'styled-components'

type LatestBlogPostsCarouselUiProps = {
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
}
const LatestBlogPostsCarouselUi = styled.div<LatestBlogPostsCarouselUiProps>`
  ${paddingsCss};
  ${p => p.theme.isEditorMobileMode && mobilePaddingsCss}
  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
  }
`

export default LatestBlogPostsCarouselUi
